import Typography from '@mui/material/Typography';
import MainImageCardDashboard3 from "../../../components/Cards/MainImageCardDashboard3";
import HeaderCardSmall from '../../../components/Header/HeaderCardSmall';
import { bioclock } from "../../../constants";


export default function AgeCard() {

return (
<>

    <MainImageCardDashboard3

        content = {<>
            <HeaderCardSmall cardheadline={'Biological Age'} />
                <Typography variant = "h1" sx={{mt: {xs: '1.5rem', xl: '0.2rem' }, color: 'traffic.green'}}>54 <Typography component='span'>&nbsp;&nbsp;Real Age: 60</Typography></Typography>
            </>}

        photo = { bioclock } 
       
    />

</>
)};
